import { useCategorias_GastoFilterQuery } from 'src/gql/schema'
import Selector from 'src/shared/components/forms/Selector/Selector'
import { useProfile } from 'src/shared/hooks/useProfile'

export interface Category {
    name: string;
    id: string;
}

export const TODOS_CATEGORIA_FILTER = { name: "Todos", id: "" }

const CategoriasGastoSelect = ({ onSelect, value }: { onSelect: (v: Category) => void, value: Category }) => {
    const { hotel_id } = useProfile()
    const { data } = useCategorias_GastoFilterQuery({
        variables: {
            hotel_id
        }
    })
    return (
        <Selector<Category>
            value={value}
            options={[{
                label: "Todos", value: TODOS_CATEGORIA_FILTER, onClick: (v) => {
                    onSelect(v)
                }
            }, ...data?.categorias_gasto.map((categoria) => ({
                label: categoria.categoria,
                value: {
                    name: categoria.categoria,
                    id: categoria.categoria_id
                },
                onClick: (v) => {
                    onSelect(v)
                }
            })) || []]}
            iconTheme='secondary'
            icon='FilterLines'
            iconProps={{
                width: 15,
                height: 10
            }}
            iconMode
        />
    )
}

export default CategoriasGastoSelect